import { VenueMinifiedType } from '@api';
import { TouringDataTable, useManageTableContext } from '@common*';
import { useVenuesOverviewTableColumns, useVenuesTableActions } from './hooks';

type VenuesOverviewTablePropsType = {
  venues: VenueMinifiedType[];
  isPending: boolean;
};

export const VenuesOverviewTable: React.FC<VenuesOverviewTablePropsType> = ({
  venues,
  isPending,
}) => {
  const {
    tableArguments: { sorting, pagination },
  } = useManageTableContext();
  const { handleDeleteVenue, handleEditVenue } = useVenuesTableActions();
  const { columns } = useVenuesOverviewTableColumns({
    handleDeleteVenue,
  });

  return (
    <TouringDataTable<VenueMinifiedType>
      columns={columns}
      records={venues}
      onRowClick={(row) => handleEditVenue(row.record.id)}
      fetching={isPending}
      {...sorting}
      {...pagination}
    />
  );
};
